import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { MfaToMarkRegAsyncEdge } from '@app/registration/graph/edges/mfa-to-mark-reg-async.edge';
import { NodeUrlMappingService } from '@app/registration/graph/node-url-mapping.service';
import { RegistrationNode } from '@app/registration/graph/nodes/registration.node';

@Injectable({
  providedIn: 'root',
})
export class MfaNode extends RegistrationNode {
  constructor(
    mfaToMarkRegAsyncEdge: MfaToMarkRegAsyncEdge,
    nodeUrlMappingService: NodeUrlMappingService,
    router: Router,
  ) {
    super(nodeUrlMappingService, router);
    this.edges = [mfaToMarkRegAsyncEdge];
  }
}
